import { Event } from '@tribeplatform/gql-client/types'

import { HtmlContent } from '../../HtmlContent/HtmlContent.js'
import { T } from '../../i18n/index.js'

import { Section } from './Section.js'

interface Props {
  event: Event
}

export const EventAbout = ({ event }: Props) => {
  return (
    <Section
      title={
        <T id="Event.Form.Description" defaultMessage="Event description" />
      }
    >
      <article className="prose text-md text-content break-words min-w-0">
        <HtmlContent
          value={event.content}
          attachments={event.attachments}
          embeds={event.embeds}
          mentions={event.mentions}
        />
      </article>
    </Section>
  )
}
